import React, { useEffect, useState } from "react";
import "./CommunityTopicList.css";
import Dropdown from "react-bootstrap/Dropdown";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import { useSelector } from "react-redux";

import { toast } from "react-toastify";
import CustomPagination from "../../Common/Component/CustomPagination/CustomPagination";
import Modal from "react-bootstrap/Modal";
import reddelete from "../../images/red-Delete.svg";
import { useNavigate } from "react-router-dom";
import editicon from "../../images/edit-icon.svg";
import binicon from "../../images/bin-icon.svg";
import { useFormik } from "formik";
import { formikNotes } from "./validation";
import eyeimg from "../../images/eye.svg";
import {
  getComunityTopicList,
  createTopic,
  updateTopic,
  deleteTopic,
} from "../services/providerService";
import { apiUrl, PORT } from "../../environment";
import Community from "./Community";
import ReportPostList from "./ReportPostList";

export default function NotesList({ patient }) {
  const navigate = useNavigate();
  const { data } = useSelector((state) => state.login);
  const [patientMedicationPlan, setPatientMedicationPlan] = useState([]);
  const [selectedSortValue, setSelectedSortValue] = useState("");
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);
  const [searchText, setSearchText] = useState("");
  const [limit, setLimit] = useState(10);
  const [page, setPage] = useState(0);
  const [selectedValue, setSelectedValue] = useState("");
  const [editData, setEditData] = useState(null);
  const [modalShow, setModalShow] = React.useState(false);
  const [deleteModelShow, setDeleteModelShow] = React.useState(false);
  const [modalViewShow, setModalViewShow] = React.useState(false);

  const [selectedCategoryValue, setSelectedCategoryValue] =
    useState("Provider-Forum");
  const [activeTab, setActiveTab] = useState(
    data.role == "ADMIN" ? "Topic" : "Community"
  );

  const handleEdit = (data) => {
    setModalShow(true);
    setEditData(data);
    formik.setValues({
      _id: data._id || "",
      name: data.name || "",
      description: data.description || "",
      category: data.category || "",
    });
  };

  const handelDeleteModel = (data) => {
    formik.setValues({
      _id: data._id || "",
      name: data.name || "",
      description: data.description || "",
      category: data.category || "",
    });
    setDeleteModelShow(true);
  };

  /* Function's */
  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setLimit(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    _getForumTopicList(selectedValue, selectedCategoryValue);
  }, [page, limit]);

  const formik = useFormik({
    ...formikNotes,
    onSubmit: async (values) => {
      values.created_by = data._id;

      // Create FormData to handle file upload
      const formData = new FormData();
      formData.append("name", values.name);
      formData.append("description", values.description);
      formData.append("category", values.category);
      formData.append("created_by", values.created_by);

      // Check if there is an image and append it to the FormData
      if (values.image) {
        formData.append("image", values.image);
      }

      try {
        let res;
        if (values._id) {
          formData.append("_id", values._id);

          // Update topic
          res = await updateTopic(formData, values._id);
        } else {
          // Create topic
          res = await createTopic(formData);
        }

        formik.setValues({
          name: "",
          description: "",
          image: null,
        });

        if (res.status === "SUCCESS") {
          _getForumTopicList(selectedValue, selectedCategoryValue);
          toast.success(res.data.message);
          setModalShow(false);
        } else {
          toast.error(res.data.message);
          setModalShow(false);
        }
      } catch (error) {
        toast.error("Failed!");
        setModalShow(false);
      }
    },
  });

  const ViewNote = (note) => {
    formik.setValues({
      _id: note._id || "",
      name: note.name || "",
      description: note.description || "",
      category: note.category || "",
      image: note.image || "",
    });
    setModalViewShow(true);
  };

  const _getForumTopicList = async (
    eventKey,
    category = "",
    searchText = ""
  ) => {
    try {
      const response = await getComunityTopicList({
        page: page + 1,
        limit,
        searchKey: searchText,
        category: category,
        sortBy: eventKey,
      });

      setPatientMedicationPlan(response.data?.items || []);
      setTotalPages(response.data?.totalPages || 0);
      setTotalItems(response.data?.totalItems || 0);
    } catch (error) {
      toast.error("Please try again later");
    }
  };

  const handleSelect = (eventKey) => {
    setSelectedValue(eventKey); // Update the state with the selected value
    _getForumTopicList(eventKey, selectedCategoryValue);
  };

  const handleCategorySelect = (eventKey) => {
    setSelectedCategoryValue(eventKey); // Update the state with the selected value
    _getForumTopicList(selectedValue, eventKey);
  };

  const deleteNote = async () => {
    await deleteTopic(formik.values);
    _getForumTopicList(selectedSortValue, selectedCategoryValue);
    setDeleteModelShow(false);
  };

  const handleSearchChange = (e) => {
    const query = e.target.value.trim();
    setSearchText(query);
    if (query.length >= 3 || query.length === 0) {
      _getForumTopicList(selectedSortValue, selectedCategoryValue, query);
    }
  };

  const redirectToProfile = (note) => {
    navigate("/admin/patient", { state: { patient: note } });
  };
  return (
    <>
      <div className="Dashboard-wrapper">
        <div className="graph-btns tabs mb-3">
          {data.role == "ADMIN" && (
            <button
              className={activeTab === "Topic" ? "active" : ""}
              onClick={() => setActiveTab("Topic")}
            >
              Topic
            </button>
          )}
          <button
            className={activeTab === "Community" ? "active" : ""}
            onClick={() => setActiveTab("Community")}
          >
            Community
          </button>

          {data.role == "ADMIN" && (
            <button
              className={activeTab === "Report Content" ? "active" : ""}
              onClick={() => setActiveTab("Report Content")}
            >
              Reported Post
            </button>
          )}
        </div>

        {activeTab === "Topic" && (
          <div className="dashboard-inner-wrapper">
            <div className="Dashboard-lft-blk">
              <div className="add-doctor">
                <Form>
                  <Form.Group controlId="searchInput">
                    <Form.Control
                      type="search"
                      aria-label="Search"
                      value={searchText}
                      onChange={handleSearchChange}
                      placeholder="Search Community Topic ..."
                    />
                  </Form.Group>
                </Form>

                {/* <Link to="/admin/patient/add-note"> */}
                <Button
                  className="filled-btn"
                  onClick={() => {
                    setModalShow(true);
                    formik.setValues({
                      name: "",
                      description: "",
                      category: "",
                    });
                  }}
                >
                  Add Topics
                </Button>
                {/* </Link> */}

                <Dropdown
                  className="patient-info-dropdown "
                  onSelect={handleCategorySelect}
                >
                  <Dropdown.Toggle className="db-dropdown h-100">
                    {selectedCategoryValue === ""
                      ? "category"
                      : selectedCategoryValue}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="All-Record">
                      All Records
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="Provider-Forum">
                      Provider-Forum
                    </Dropdown.Item>
                    <Dropdown.Item eventKey="Patient-Forum">
                      Patient-Forum
                    </Dropdown.Item>
                  </Dropdown.Menu>
                </Dropdown>

                <Dropdown
                  className="patient-info-dropdown "
                  onSelect={handleSelect}
                >
                  <Dropdown.Toggle className="db-dropdown h-100">
                    {selectedValue === ""
                      ? "Sort By"
                      : selectedValue === "recent"
                        ? "recent"
                        : "oldest"}
                  </Dropdown.Toggle>

                  <Dropdown.Menu>
                    <Dropdown.Item eventKey="">Default</Dropdown.Item>

                    <Dropdown.Item eventKey="recent">Recent</Dropdown.Item>
                    <Dropdown.Item eventKey="oldest">Oldest</Dropdown.Item>
                    {/* <Dropdown.Item eventKey="low-icbps">Low ICBPS</Dropdown.Item> */}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {/* table for tratment lis  */}
              <div className="table-responsive dashboard-table">
                <table className="patients-table">
                  <thead>
                    <tr className="t-row-block">
                      <th scope="col">Sr No</th>
                      {/* Set fixed width for the Title column */}
                      <th scope="col">Name</th>
                      <th scope="col">Category</th>
                      <th scope="col">Created At</th>
                      <th scope="col">Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {patientMedicationPlan?.length > 0 ? (
                      patientMedicationPlan?.map((note, index) => (
                        <tr key={note.id || index}>
                          <td scope="row" style={{ borderLeft: "0px" }}>
                            {++index}
                          </td>
                          <td>{note.name}</td>

                          <td>{note?.category}</td>

                          <td style={{ borderRight: "0px" }}>
                            {new Date(note?.createdAt).toLocaleString("en-US", {
                              hour12: true,
                              year: "numeric",
                              month: "numeric",
                              day: "numeric",
                              hour: "2-digit",
                              minute: "2-digit",
                            })}
                          </td>
                          <td>
                            <div className="d-flex gap-3">
                              <a
                                className="edit-del-icon eye-edit-del eye-img"
                                onClick={() => {
                                  ViewNote(note);
                                }}
                              >
                                <img src={eyeimg} alt="view" />
                              </a>

                              <a
                                className="edit-del-icon eye-edit-del eye-img"
                                onClick={() => {
                                  handleEdit(note);
                                }}
                              >
                                <img src={editicon} alt="edit" />
                              </a>
                              <a
                                className="edit-del-icon eye-edit-del eye-img"
                                onClick={() => handelDeleteModel(note)}
                              >
                                <img src={binicon} alt="delete" />
                              </a>
                            </div>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="8" className="text-center">
                          Topic not found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

              <div className="pagination-blk">
                <CustomPagination
                  totalItems={totalItems}
                  page={page}
                  onPageChange={handleChangePage}
                  limit={limit}
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </div>
            </div>
          </div>
        )}

        {activeTab === "Community" && (
          <div className="dashboard-inner-wrapper ">
            <div className="Dashboard-lft-blk p-3">
              <Community />
            </div>
          </div>
        )}

        {activeTab === "Report Content" && (
          <div className="dashboard-inner-wrapper ">
            <div className="Dashboard-lft-blk p-3">
              <ReportPostList />
            </div>
          </div>
        )}
        {/* add /edit note modal */}
        <Modal
          className="dlt-patient-modal add-edit-notes-modal"
          show={modalShow}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => setModalShow(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>
              {formik.values._id ? "Edit Topic" : "Add New Topic"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Form className="" onSubmit={formik.handleSubmit}>
              <div className="">
                <div className="form-control-area">
                  <Form.Group
                    className="mb-3 text-start"
                    controlId="exampleForm.ControlInputFirstName"
                  >
                    <Form.Label className="details">
                      Topic<span className="asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      placeholder="Enter topic name"
                      name="name"
                      keyField={"name"}
                      formik={formik}
                      value={formik.values.name}
                      onChange={(e) =>
                        formik.setFieldValue("name", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.name && formik.errors.name ? (
                      <div className="text-danger">{formik.errors.name}</div>
                    ) : null}
                  </Form.Group>

                  <Form.Group
                    className="mb-4 text-start"
                    controlId="exampleForm.ControlInputDescription"
                  >
                    <Form.Label className="details">
                      Description<span className="asterisk">*</span>
                    </Form.Label>
                    <Form.Control
                      type="text"
                      as="textarea"
                      rows={4}
                      placeholder="Enter description here..."
                      name="description"
                      keyField={"description"}
                      formik={formik}
                      value={formik.values.description}
                      onChange={(e) =>
                        formik.setFieldValue("description", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                    />
                    {formik.touched.description && formik.errors.description ? (
                      <div className="text-danger">
                        {formik.errors.description}
                      </div>
                    ) : null}
                  </Form.Group>

                  <Form.Group className="mb-3 text-start">
                    <Form.Label className="details">
                      Category <span className="asterisk">*</span>
                    </Form.Label>
                    <Form.Select
                      className="selected-fields "
                      name="category"
                      keyField={"category"}
                      formik={formik}
                      value={formik.values.category}
                      onChange={(e) =>
                        formik.setFieldValue("category", e.target.value)
                      }
                      onBlur={formik.handleBlur}
                      isInvalid={
                        formik.touched.category && !!formik.errors.category
                      }
                    >
                      <option value="">Select category</option>
                      <option value="Patient-Forum">Patient-Forum</option>
                      <option value="Provider-Forum">Provider-Forum</option>
                    </Form.Select>
                    {formik.touched.category && formik.errors.category ? (
                      <div className="text-danger">
                        {formik.errors.category}
                      </div>
                    ) : null}
                  </Form.Group>
                  <Form.Group className="mb-3 text-start">
                    <Form.Label className="details">
                      Upload Image<span className="asterisk">*</span>
                    </Form.Label>
                    <div className="custom-file-upload-wrapper">
                      <input
                        type="file"
                        accept="image/*"
                        name="image"
                        id="image-upload"
                        className="custom-file-input"
                        onChange={(e) =>
                          formik.setFieldValue("image", e.target.files[0])
                        }
                        onBlur={formik.handleBlur}
                      />
                      <label htmlFor="image-upload" className="custom-file-label">
                        <span className="file-upload-button">
                          Choose File
                        </span>
                        <span className="file-name">
                          {formik.values.image?.name || "No file chosen"}
                        </span>
                      </label>
                    </div>
                    {formik.touched.image && formik.errors.image ? (
                      <div className="text-danger">{formik.errors.image}</div>
                    ) : null}
                  </Form.Group>
                </div>
              </div>

              <div className="authentication-btns d-flex justify-content-center gap-4">
                <Button
                  className="btn btn-primary outlined-btn"
                  onClick={() => setModalShow(false)}
                >
                  Cancel
                </Button>
                {formik.values._id ? (
                  <Button className="btn btn-primary filled-btn" type="submit">
                    Update
                  </Button>
                ) : (
                  <Button className="btn dark-btn btn-yes" type="submit">
                    Add
                  </Button>
                )}
              </div>
            </Form>
          </Modal.Body>
        </Modal>

        {/* view model  */}
        <Modal
          className="dlt-patient-modal add-edit-notes-modal view-modal"
          show={modalViewShow}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => setModalViewShow(false)}
        >
          <Modal.Header closeButton>
            <Modal.Title>View Topic Details</Modal.Title>
          </Modal.Header>
          <Modal.Body className="view-modal-body">
            <div className="view-media-block">
              <div className="form-control-area">
                <div className="mb-3 text-start view-field-group">
                  <Form.Label className="details">
                    Topic Name <span className="asterisk">*</span>
                  </Form.Label>
                  <div className="view-field-value">
                    {formik.values.name || "-"}
                  </div>
                </div>
                <div className="mb-4 text-start view-field-group">
                  <Form.Label className="details">
                    Description<span className="asterisk">*</span>
                  </Form.Label>
                  <div className="view-field-value view-description">
                    {formik.values.description || "-"}
                  </div>
                </div>

                <div className="mb-4 text-start view-field-group">
                  <Form.Label className="details">
                    Category<span className="asterisk">*</span>
                  </Form.Label>
                  <div className="view-field-value">
                    {formik.values.category || "-"}
                  </div>
                </div>

                {formik.values.image && (
                  <div className="mb-4 text-start view-field-group">
                    <Form.Label className="details">
                      Image <span className="asterisk">*</span>
                    </Form.Label>
                    <div className="view-image-container">
                      <img
                        className="view-media-img"
                        src={`${apiUrl}${PORT}/user-service/getimages/${formik.values.image}`}
                        alt="Topic"
                        onError={(e) => {
                          e.target.src = "";
                          e.target.style.display = "none";
                        }}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>

            <div className="authentication-btns d-flex justify-content-center gap-4">
              <Button
                className="btn btn-primary outlined-btn"
                onClick={() => setModalViewShow(false)}
              >
                Close
              </Button>
            </div>
          </Modal.Body>
        </Modal>

        {/* delete patient modal */}
        <Modal
          className="dlt-patient-modal"
          show={deleteModelShow}
          size="lg"
          aria-labelledby="contained-modal-title-vcenter"
          centered
          onHide={() => setDeleteModelShow(false)}
        >
          <Modal.Body>
            <div className="d-flex justify-content-center mb-3">
              <div className="delete-img">
                <img src={reddelete} alt="img"></img>
              </div>
            </div>
            <h4>Are you sure? </h4>
            <p>You want to detele this topic</p>
            <div className="authentication-btns d-flex justify-content-center gap-4">
              <Button
                className="btn outlined-btn border-btn btn-no"
                onClick={() => setDeleteModelShow(false)}
              >
                No
              </Button>
              <Button
                className="btn dark-btn btn-yes"
                onClick={() => deleteNote()}
              >
                Yes
              </Button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}
